// Dependencies.
import styled from 'styled-components'

import { colors, icons, forScreensGreaterThanMobileWidth } from '../../../utils'
import { H5 } from '../../H5'
import { EventHookInterface } from '../../../types'
import { Hyperlink } from '../../Hyperlink'

// Div.
const Div = styled.div`
  align-items: center;
  border: 2px solid #f1f2f5;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  padding: 10px;
  width: 100%;
  ${forScreensGreaterThanMobileWidth`
    height: 45px;
  `}

  a {
    word-break: break-all;
    color: ${colors.purple};
    text-decoration: none;
    font-weight: 500;
  }

  .videoIcon {
    height: 24px;
    margin-right: 7px;
    object-fit: contain;
    width: 24px;
  }
`

// Props.
interface Props {
  eventHook: EventHookInterface
}

// Meeting Link Field.
export const MeetingLinkInput: React.FC<Props> = (props) => {
  const { eventHook } = props
  const { video_url } = eventHook.value

  // ..
  return (
    <Div>
      {/* Icon. */}
      <img className="videoIcon" src={icons.link} />

      {/* Copy. */}
      <Hyperlink href={video_url ? video_url : ''}>{video_url}</Hyperlink>
    </Div>
  )
}
